// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { IsoDateString } from "src/types/dateTime";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace InvoiceOperationApi {
	export async function printInvoice(args: { invoiceId: number }): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/printInvoice",
			method: "POST",
			data: {
				invoiceId: args.invoiceId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printInvoices(args: {
		invoiceIds: Array<number>;
	}): Promise<Array<FrontendDownloadFileHandle>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/printInvoices",
			method: "POST",
			data: {
				invoiceIds: args.invoiceIds,
			},
		});
		return response as Array<FrontendDownloadFileHandle>;
	}

	export async function printInvoicingReport(args: {
		fromDate: IsoDateString;
		toDate: IsoDateString;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/printInvoicingReport",
			method: "POST",
			data: {
				fromDate: args.fromDate,
				toDate: args.toDate,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function copyInvoicesToAccounting(args: { invoiceIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/copyInvoicesToAccounting",
			method: "POST",
			data: {
				invoiceIds: args.invoiceIds,
			},
		});
		return response as void;
	}

	export async function markInvoicesAsCopiedToAccounting(args: { invoiceIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/markInvoicesAsCopiedToAccounting",
			method: "POST",
			data: {
				invoiceIds: args.invoiceIds,
			},
		});
		return response as void;
	}
}
